































































































































import Vue from "vue";
import search from "./components/Search.vue";
import result from "./components/Result.vue";
import process from "./components/Process.vue";
import {
  SuggestionDTO,
  suggest,
  ProcessDTO,
  ResponseDTO,
} from "./suggestion-service";
export default Vue.extend({
  name: "app",
  data: function () {
    return {
      searchTerm: "",
      response: null as ResponseDTO | null,
      suggestion: null as SuggestionDTO | null,
      process: null as ProcessDTO | null,
      searchButtonLoading: false,
      processClicked: false,
      exampleButtonLoading: false,
      showProcess: true,
      image: {
        backgroundImage: "url(./assets/Eliezer_Ben-Yehuda_picture.jpg)",
      },
    };
  },
  props: {},
  components: {
    search,
    result,
    process,
  },
  methods: {
    disableProcess() {
      this.showProcess = false;
    },
    async onTextBoxSearch(query: string) {
      this.processClicked = false;
      this.searchTerm = query;
      this.searchButtonLoading = true;
      this.response = await suggest(query);
      this.suggestion = this.response.suggestions;
      if (this.suggestion) {
        this.showProcess = true;
      }
      this.process = this.response.process;
      this.searchButtonLoading = false;
    },
    async onButtonSearch(query: { number: number; query: string }) {
      this.processClicked = false;
      this.searchTerm = query.query;
      this.searchButtonLoading = true;
      this.exampleButtonLoading = true;
      this.response = await suggest(query.query);
      this.suggestion = this.response.suggestions;
      if (this.suggestion) {
        this.showProcess = true;
      }
      this.process = this.response.process;
      this.exampleButtonLoading = false;
      this.searchButtonLoading = false;
      window.scrollTo(0, 900);
    },
    onProcessClick() {
      this.processClicked = true;
      window.scrollTo(0, 1300);
    },
  },
});
